import React from 'react';
import { Paper, Tab, Tabs } from '@mui/material';
import { DayTab } from './gridDays';

/**
 * The day ladder: one tab per calendar day from admission through today
 * (or discharge). Orders are day-scoped, so each tab is that day's sheet;
 * "Duplicate to today" carries a previous day's orders forward.
 */
interface DayLadderProps {
  tabs: DayTab[];
  selectedDayKey: string;
  onSelect: (dayKey: string) => void;
}

const DayLadder: React.FC<DayLadderProps> = ({ tabs, selectedDayKey, onSelect }) => (
  <Paper square elevation={0} sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
    <Tabs
      value={selectedDayKey}
      onChange={(_e, value) => onSelect(value)}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{ minHeight: 40, '& .MuiTab-root': { minHeight: 40, py: 0.5, textTransform: 'none' } }}
    >
      {tabs.map((tab) => (
        <Tab key={tab.dayKey} value={tab.dayKey} label={tab.label} data-testid={`day-tab-${tab.dayKey}`} />
      ))}
    </Tabs>
  </Paper>
);

export default DayLadder;
